/* eslint-disable */

import moment from 'moment';

const INITIAL_STATE = {
  currentCertificate: {
    assetId: 0,
    powerInW: null,
    productionDate: moment().set({hour:0,minute:0,second:0,millisecond:0}).subtract(1, 'days').toDate()
  },
  currentCertificateSecretWord: {
    productionAssetSecretWord :'',
    consumptionAssetSecretWord : ''
  },
  hourlyCertificates: [],
  certificates: [],
  allCertificates: [],
  consumptionCertificates: [],
  consumptionCertificates: [],
  irecs: [],
  error: { message : '', isVisible: false },
  loading: false,
  loadingCertificate: false,
  loadingSecretWord: false,
  loadingHourlyCertificates: false,
  retiringCertificateId: null,
  isCertificateAuthentic: 'unknown',
  order: 'desc',
  orderBy: '_productionDateEnd',
  selected: [],
  page: 0,
  rowsPerPage: 10,
  dialogMatchingDateOpen: false,
  dialogMatchingWarningOpen: false,
  dialogSecretWordOpen: false,
  dialogHourlyCertificatesOpen: false,
  dialogLoadingPdfOpen: false,
  matchingDate: moment().subtract(1, 'days').toDate(),
  dialogProductionDateOpen: false,
  loadingMatching: false,
  newOwner: {
    address: null,
    name: null,
  },
  loadingTransferCertificate: false,
  generateCertificatesChecked: false,
  forceCertificatesGenerationChecked: false,
  loadingCheckCertificates: false,
  existingCertificates: null,
  localIrecDataset: null,
  loadingIrecDataset: false,
  irecCountry: null,
  irecYear: null,
  irecAsset: null,
  irecVolume: 0,
  irecCustomerOrganization: null,
  loadingIrecs: false,
  customerOrganizationsWithIrecFeatureEnabled: [],
  userRelatedUtilityOrganization: undefined,
  lastCertificatesDataLoad: 0
};

const certificatesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {

    //Certificates CRUD
    case 'CREATE_CERTIFICATE_START':

      return { ...state,  loading: true }
    case 'CREATE_CERTIFICATE_SUCCESS':

      return { ...state,  loading: false }
    case 'CREATE_CERTIFICATE_FAIL':

      return { ...state,  loading: false }

    //Certificates data changing

    case 'TOGGLE_MATCHINGDATE_CERTIFICATES':

      const dialogMatchingDateOpen = !state.dialogMatchingDateOpen;
      return { ...state, dialogMatchingDateOpen }
    case 'TOGGLE_MATCHINGWARNING_CERTIFICATES':

      const dialogMatchingWarningOpen = !state.dialogMatchingWarningOpen;
      return { ...state, dialogMatchingWarningOpen }

    case 'TOGGLE_SECRET_WORD_DIALOG_CERTIFICATES':

      const dialogSecretWordOpen = !state.dialogSecretWordOpen;
      return { ...state, dialogSecretWordOpen }

    case 'TOGGLE_HOURLY_CERTIFICATES_DIALOG':
      const dialogHourlyCertificatesOpen = !state.dialogHourlyCertificatesOpen;
      return { ...state, dialogHourlyCertificatesOpen }

    case 'TOGGLE_LOADING_PDF_DIALOG_CERTIFICATES':

      const dialogLoadingPdfOpen = !state.dialogLoadingPdfOpen;
      return { ...state, dialogLoadingPdfOpen }

    case 'CERTIFICATE_LOADING_PDF_START':

      return { ...state, dialogLoadingPdfOpen: true }

    case 'CERTIFICATE_LOADING_PDF_SUCCESS':

      return { ...state, dialogLoadingPdfOpen: false }



    case 'TOGGLE_GENERATE_MATCHING_CERTIFICATES':

      const generateCertificatesChecked = !state.generateCertificatesChecked;
      return { ...state, generateCertificatesChecked }

    case 'TOGGLE_FORCE_CERTIFICATES_GENERATION':

      const forceCertificatesGenerationChecked = !state.forceCertificatesGenerationChecked;
      return { ...state, forceCertificatesGenerationChecked }




    case 'SET_MATCHINGDATE_CERTIFICATES':

      const matchingDate = action.payload;
      return { ...state, matchingDate }

    case 'SET_CUSTOMER_ORGANIZATIONS_WITH_IREC_FEATURE_ENABLED':
      return { ...state, customerOrganizationsWithIrecFeatureEnabled: action.payload}


    case 'MATCHING_CHECK_CERTIFICATES_START':

      return { ...state,  loadingCheckCertificates: true, existingCertificates: null }
    case 'MATCHING_CHECK_CERTIFICATES_SUCCESS':

      return { ...state,  loadingCheckCertificates: false, existingCertificates: action.payload}
    case 'MATCHING_CHECK_CERTIFICATES_FAIL':

      return { ...state,  loadingCheckCertificates: false, existingCertificates: null }

    case 'MATCHING_CERTIFICATES_START':

      return { ...state,  loadingMatching: true }
    case 'MATCHING_CERTIFICATES_SUCCESS':

      return { ...state,  loadingMatching: false }
    case 'MATCHING_CERTIFICATES_FAIL':

      return { ...state,  loadingMatching: false }

    case 'ASSET_ID_CHANGED':

      return {
        ...state,
        currentCertificate: {
          ...state.currentCertificate,
          assetId: action.payload
        }
      }



    case 'TOGGLE_PRODUCTION_DATE_CERTIFICATES':

      const dialogProductionDateOpen = !state.dialogProductionDateOpen;
      return { ...state, dialogProductionDateOpen }

    case 'SET_PRODUCTION_DATE_CERTIFICATES':


      return {
        ...state,
        currentCertificate: {
          ...state.currentCertificate,
          productionDate: action.payload
        }
      }

    case 'POWER_CHANGED':

      return {
        ...state,
        currentCertificate: {
          ...state.currentCertificate,
          powerInW: action.payload
        }
      }


    case 'OWNER_CHANGED':

      let newOwner = state.currentCertificate.owners.find(user => {
        return user.address === action.payload
      })

      return {
        ...state,
        newOwner: {
          address: action.payload,
          name: newOwner.offchainData.user_metadata.name,
        }
      }

    case 'TRANSFERING_CERTIFICATE_START':

      return { ...state,  loadingTransferCertificate: true }
    case 'TRANSFERING_CERTIFICATE_SUCCESS':

      let certificate = action.payload;
      let _newOwner = state.currentCertificate.owners.find(user => {
        return user.address === certificate.owner
      })



      return {
        ...state,
        loadingTransferCertificate: false,
        currentCertificate: {
          ...state.currentCertificate,
          owner: _newOwner.address,
          ownerName: _newOwner.offchainData.user_metadata.organization,
        }
      }

    case 'TRANSFERING_CERTIFICATE_FAIL':

      return { ...state,  loadingTransferCertificate: false }

    //Getting certificates
    case 'GET_CERTIFICATES_START':
      return { ...state,  loading: true }

    case 'SET_LAST_CERTIFICATES_DATA_LOAD':
      return { ...state,  lastCertificatesDataLoad: moment().unix() }

    case 'RESET_LAST_CERTIFICATES_DATA_LOAD':
      return { ...state,  lastCertificatesDataLoad: 0 }

    case 'GET_IRECS_START':
      return { ...state,  loadingIrecs: true }

    case 'FILTER_ON_PRODUCTION_CERTIFICATES': 
      return { ...state,  certificates: state.productionCertificates, loading: false, order: state.order, orderBy: state.orderBy }
    
      case 'FILTER_ON_CONSUMPTION_CERTIFICATES':
      return { ...state,  certificates: state.consumptionCertificates, loading: false, order: state.order, orderBy: state.orderBy }
    
      case 'FILTER_ON_IRECS':
      return { ...state, loading: false, order: state.order, orderBy: state.orderBy }
    
      case 'SET_ALL_CERTIFICATES':
      return { ...state,  allCertificates: action.payload }

      case 'SET_CONSUMPTION_CERTIFICATES':
      return { ...state,  consumptionCertificates: action.payload }

      case 'SET_IRECS':
      return { ...state, irecs: action.payload, loadingIrecs: false }
    
      case 'SET_PRODUCTION_CERTIFICATES':
      return { ...state,  productionCertificates: action.payload }
    
      case 'GET_CERTIFICATES_FAIL':
      return { ...state,  loading: false }

      case 'GET_IRECS_FAIL':
      return { ...state,  loadingIrecs: false }

    case 'GET_CERTIFICATE_START':

      return { ...state,  loading: true }
    case 'GET_CERTIFICATE_SUCCESS':

      return { ...state,  currentCertificate: action.payload, loading: false }
    case 'GET_CERTIFICATE_FAIL':

      return { ...state,  loading: false }
    case 'SORT_CERTIFICATES':

      const certificates = action.payload.certificates;
      const order = action.payload.order;
      const orderBy = action.payload.orderBy;
      return { ...state, certificates, order, orderBy }
    case 'CHANGE_PAGE':
      const page = action.payload.page;
      return { ...state, page }
    case 'CHANGE_ROWS_PER_PAGE':

      const rowsPerPage = action.payload.rowsPerPage;
      return { ...state, rowsPerPage }
    case 'GET_CERTIFICATE_START':

      return { ...state,  loading: true }
    case 'GET_CERTIFICATE_SUCCESS':

      return { ...state,  currentCertificate: action.payload, loading: false }
    case 'GET_CERTIFICATE_FAIL':

      return { ...state }


    case 'RETIRE_CERTIFICATE_START':

      return { ...state,  retiringCertificateId: action.payload }
    case 'RETIRE_CERTIFICATE_SUCCESS':

      const retiredCertificateIds = action.payload
      const updatedCertificates = state.certificates.map(certificate => {
        if( retiredCertificateIds.includes(certificate._certificateId) ) {
          certificate._retired = true;
        }
        return certificate;
      })
      return { ...state, certificates: updatedCertificates, retiringCertificateId: null }
    case 'RETIRE_CERTIFICATE_FAIL':

      return { ...state, retiringCertificateId: null }

    //Checking certificate authenticity
    case 'CHECK_CERTIFICATE_START':

      return { ...state,  loadingCertificate: true, isCertificateAuthentic: false }
    case 'CHECK_CERTIFICATE_SUCCESS':

      return { ...state,  currentCertificate: action.payload, loadingCertificate: false, isCertificateAuthentic: true }
    case 'CHECK_CERTIFICATE_FAIL':

      return { ...state,  currentCertificate: action.payload, loadingCertificate: false, isCertificateAuthentic: false }
        
    case "SET_USER_RELATED_UTILITY_ORGANIZATION":
      return {...state, userRelatedUtilityOrganization: action.payload}

    //Loading the certificate secret word
    case 'LOAD_SECRET_WORD_START':

      const loadCertificateSecretWord = {
        productionAssetSecretWord :'loading...',
        consumptionAssetSecretWord : ''
      }
      return { ...state,  currentCertificateSecretWord: loadCertificateSecretWord,  loadingSecretWord: true }

    case 'LOAD_HOURLY_CERTIFICATES_START':
      return { ...state,  loadingHourlyCertificates: true }

    case 'LOAD_SECRET_WORD_SUCCESS':

      const successCertificateSecretWord = {
        productionAssetSecretWord : action.payload.productionAssetSecretWord,
        consumptionAssetSecretWord : action.payload.consumptionAssetSecretWord
      }

      return { ...state,  currentCertificateSecretWord: successCertificateSecretWord, loadingSecretWord: false }

    case 'LOAD_HOURLY_CERTIFICATES_SUCCESS':
      return { ...state,  hourlyCertificates: action.payload, loadingHourlyCertificates: false }

    case 'IREC_COUNTRY_CHANGED': 
      return {
        ...state,
        irecCountry: action.payload
      };

    case 'IREC_YEAR_CHANGED': 
      return {
        ...state,
        irecYear: action.payload
      };

    case 'IREC_ASSET_CHANGED': 
      return {
        ...state,
        irecAsset: action.payload
      };

    case 'IREC_VOLUME_CHANGED': 
      return {
        ...state,
        irecVolume: action.payload
      };

    case 'IREC_CUSTOMER_ORGANIZATION_CHANGED': 
      return {
        ...state,
        irecCustomerOrganization: action.payload
      };

    case 'IREC_DATASET_CHANGED': 
      return {
        ...state,
        localIrecDataset: action.payload
      };

    case "UPLOAD_IREC_DATA_START":
      return {
        ...state,
        loadingIrecDataset: true
      };

    case "UPLOAD_IREC_DATA_ENDED":
      return {
        ...state,
        loadingIrecDataset: false
      };

    case 'LOAD_SECRET_WORD_FAIL':

      const failCertificateSecretWord = {
        productionAssetSecretWord :'An error has occured',
        consumptionAssetSecretWord : ''
      }
      return { ...state,  currentCertificateSecretWord: failCertificateSecretWord, loadingSecretWord: false }

    case 'LOAD_HOURLY_CERTIFICATES_FAIL':
      return { ...state, loadingHourlyCertificates: false }

    case 'LOGOUT_SUCCESS':

      return INITIAL_STATE

    case "RESET_CHECK_CERTIFICATE":
      return {
        ...state,
        currentCertificate: {
          assetId: 0,
          powerInW: null,
          productionDate: moment().set({hour:0,minute:0,second:0,millisecond:0}).subtract(1, 'days').toDate()
        },
        loadingCertificate: false,
        isCertificateAuthentic: 'unknown'
      };

    default:
      return state
  }
}

export default certificatesReducer



// WEBPACK FOOTER //
// ./src/reducers/certificatesReducer.js